import PropTypes from "prop-types";

import { Accordion } from "components/layout";
import { trans } from "src/translations";

import styles from "./ManifestDetailsTable.scss";
import {
  ManifestPropertiesTable,
  getAttributesKeys,
} from "./ManifestPropertiesTable";

const SHORT_MANIFEST_MAX_LENGTH = 3;

export const ManifestDetailsTable = ({
  attributes,
  collapsable = false,
  deleted = false,
  header = trans.APP_DETAILS_MANIFEST__CONFIG_HEADER(),
  loading,
  subheader,
}) => {
  const attributeCount = getAttributesKeys(attributes).length;
  const expanded =
    !collapsable || loading || attributeCount <= SHORT_MANIFEST_MAX_LENGTH;

  return (
    <Accordion
      key={loading}
      className={styles.container}
      disabled={expanded}
      header={header}
      headerType="section"
      initialExpanded={expanded}
      longContent
      preview={12}
    >
      <div className={styles.content}>
        {subheader}
        <ManifestPropertiesTable
          attributes={attributes}
          deleted={deleted}
          loading={loading}
        />
      </div>
    </Accordion>
  );
};

ManifestDetailsTable.propTypes = {
  attributes: PropTypes.object.isRequired,
  collapsable: PropTypes.bool,
  deleted: PropTypes.bool,
  header: PropTypes.string,
  loading: PropTypes.bool.isRequired,
  subheader: PropTypes.node,
};
